module.exports = {
    notAllowed: {
        errorTitle: 'contractsView-depositThirteenMonthsCustomErrorNotAllowedTitle',
        errorBody: 'contractsView-openyoungDataStep2TabForWhom',
        contentBuilder: 'depositThirteenMonthsDueDates_customErrorNotAllowed',
        backButtonLabel: 'contractsView-errorBackButtonLabelGlobal',
        backButtonLink: '/myprofile/global'
    }
}
